import { FC, ReactNode, useEffect } from 'react';

import { useQueryFeatureFlags } from '@modules/feature-flags/hooks';
import { useFeatureFlagsStore } from '@modules/feature-flags/store';

const FeatureFlags: FC<{ children: ReactNode }> = ({ children }) => {
  const { data } = useQueryFeatureFlags();
  const setFeatureFlags = useFeatureFlagsStore((store) => store.setFeatureFlags);

  useEffect(() => {
    if (data !== undefined) {
      setFeatureFlags(data);
    }
  }, [data]);

  return <>{children}</>;
};

export default FeatureFlags;
